import configLoader from '@engine/utils/ConfigLoader'

/**
 * Google Analytics 4 Configuration
 * Contains tracking IDs and settings for GA4 integration
 */

export default {
    // Dynamic configuration - loaded at runtime
    get measurementId() {
        try {
            return configLoader.isLoaded 
                ? configLoader.get('analytics.ga4.measurementId', 'G-KYMJTE40EJ')
                : 'G-KYMJTE40EJ' // Fallback when config not loaded yet
        } catch (error) {
            return 'G-KYMJTE40EJ' // Fallback on error
        }
    },
    
    get enabled() {
        try {
            return configLoader.isLoaded 
                ? configLoader.get('analytics.ga4.enabled', false)
                : false // Fallback when config not loaded yet
        } catch (error) {
            return false // Fallback on error
        }
    },
    
    // Debug mode - true for development builds
    get debug() {
        // Check if we're in development mode by checking the hostname or webpack mode
        return (typeof window !== 'undefined' && 
                (window.location.hostname === 'localhost' || 
                 window.location.hostname === '127.0.0.1')) || false
    },
    
    // Custom events configuration
    events: {
        // User engagement events
        login: 'login',
        logout: 'logout',
        sign_up: 'sign_up',
        
        // Game-specific events
        room_visit: 'room_visit',
        game_start: 'game_start',
        game_end: 'game_end',
        level_up: 'level_up',
        
        // E-commerce events (for coin purchases, items, etc.)
        purchase: 'purchase',
        add_to_cart: 'add_to_cart',
        view_item: 'view_item',
        
        // Social events
        share: 'share',
        chat_message: 'chat_message',
        buddy_request: 'buddy_request',
        buddy_accept: 'buddy_accept',
        
        // Custom Club Penguin events
        clothing_change: 'clothing_change',
        igloo_visit: 'igloo_visit',
        minigame_join: 'minigame_join',
        pet_adopt: 'pet_adopt',
        emote_use: 'emote_use',
        snowball_throw: 'snowball_throw',
        coin_earn: 'coin_earn'
    },
    
    // Custom dimensions and metrics
    customDimensions: {
        player_id: 'custom_dimension_1',
        world_id: 'custom_dimension_2',
        room_id: 'custom_dimension_3',
        penguin_color: 'custom_dimension_4',
        member_status: 'custom_dimension_5'
    },
    
    // Enhanced e-commerce settings
    ecommerce: {
        currency: 'coins',
        value_multiplier: 0.01 // Convert coins to a standard currency value for GA4
    }
}